import { useEffect, useState } from 'react';
import { v4 } from 'uuid';

/**
 * Хук для создания и хранения sessionId пользователя в sessionStorage
 * @returns строка с id текущей сессии
 */
const useSessionId = () => {
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    const currentSessionId = sessionStorage.getItem('user_session_id');

    if (currentSessionId) {
      setSessionId(currentSessionId);
    } else {
      const newSessionId = v4();
      sessionStorage.setItem('user_session_id', newSessionId);
      setSessionId(newSessionId);
    }
  }, []);

  return sessionId;
};

export default useSessionId;
